// Servicio de Configuración de Ganancia
// Gestiona la configuración general de ganancia del sistema

import { getDocument, createDocument, updateDocument } from './firestore.service'

const PROFIT_SETTINGS_COLLECTION = 'profitSettings'

/**
 * Obtener la configuración de ganancia general
 * @returns {Promise<Object>} Configuración de ganancia
 */
export const getProfitSettings = async () => {
  try {
    // Intentar obtener el documento 'main' directamente
    try {
      const settings = await getDocument(PROFIT_SETTINGS_COLLECTION, 'main')
      if (settings) {
        return settings
      }
    } catch (error) {
      // Si no existe, continuar para crear uno por defecto
    }
    
    // Si no existe, crear uno por defecto
    const defaultSettings = {
      id: 'main',
      defaultProfitPercentage: 30, // 30% por defecto
      updatedAt: new Date()
    }
    
    const docId = await createDocument(PROFIT_SETTINGS_COLLECTION, defaultSettings)
    return { id: docId, ...defaultSettings }
  } catch (error) {
    console.error('Error obteniendo configuración de ganancia:', error)
    throw error
  }
}

/**
 * Actualizar la configuración de ganancia general
 * @param {Object} settingsData - Datos de configuración
 * @returns {Promise<void>}
 */
export const updateProfitSettings = async (settingsData) => {
  try {
    // Intentar obtener el documento 'main'
    let existing = null
    try {
      existing = await getDocument(PROFIT_SETTINGS_COLLECTION, 'main')
    } catch (error) {
      // Si no existe, continuar para crear uno nuevo
    }
    
    const data = {
      id: 'main',
      defaultProfitPercentage: parseFloat(settingsData.defaultProfitPercentage) || 30,
      updatedAt: new Date()
    }
    
    if (existing) {
      // Actualizar documento existente
      return await updateDocument(PROFIT_SETTINGS_COLLECTION, 'main', data)
    } else {
      // Crear nuevo documento
      return await createDocument(PROFIT_SETTINGS_COLLECTION, data)
    }
  } catch (error) {
    console.error('Error actualizando configuración de ganancia:', error)
    throw error
  }
}

/**
 * Obtener el porcentaje de ganancia para una categoría
 * Si la categoría tiene profitPercentage configurado, lo retorna
 * Si no, retorna el porcentaje general
 * @param {Object} category - Objeto de categoría
 * @returns {Promise<number>} Porcentaje de ganancia
 */
export const getCategoryProfitPercentage = async (category) => {
  try {
    // Si la categoría tiene un porcentaje configurado, usarlo
    if (category && category.profitPercentage !== null && category.profitPercentage !== undefined) {
      return category.profitPercentage
    }
    
    // Si no, usar el porcentaje general
    const settings = await getProfitSettings()
    return settings.defaultProfitPercentage || 30
  } catch (error) {
    console.error('Error obteniendo porcentaje de ganancia:', error)
    // Retornar un valor por defecto en caso de error
    return 30
  }
}

